import {
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiDeleteRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Saldo Awal Piutang',
    title_form: 'Form Saldo Awal Piutang',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Saldo Awal',
        href: '/adm/fin/setting/saldo-awal',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_customer',
    sortDesc: true,
    fields: [
      {
        key: 'principle',
        label: 'Nama Pelanggan',
        sortable: true,
      },
      {
        key: 'date_piutang',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'no_invoice',
        label: 'Invoice',
      },
      {
        key: 'code_currency',
        label: 'Currency',
      },
      {
        key: 'nominal_piutang',
        label: 'Saldo Piutang',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  settingSaldoPiutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListSaldoPiutang({ commit, state }) {
    commit('settingSaldoPiutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/saldo-piutang`, params);
    commit('settingSaldoPiutang', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoPiutang', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async getDetailSaldoPiutang({ commit, state }, payload = null) {
    commit('settingSaldoPiutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/saldo-piutang/${payload.id}`);
    commit('settingSaldoPiutang', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoPiutang', {
        form: {
          ...data.form,
          ...result.data.object,
          date_piutang: result.data.object.date_piutang
            ? moment(result.data.object.date_piutang).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async createSaldoPiutang({ commit, state, dispatch }) {
    commit('settingSaldoPiutang', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/saldo-piutang`, state.data.form);
    commit('settingSaldoPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSaldoPiutang({ commit, state, dispatch }, payload = null) {
    commit('settingSaldoPiutang', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/saldo-piutang/${payload.id}`,
      state.data.form
    );

    commit('settingSaldoPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSaldoPiutang({ commit, dispatch }, payload = null) {
    commit('settingSaldoPiutang', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`fin/saldo-piutang/${payload.id}`);
    commit('settingSaldoPiutang', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
